import React, { useCallback, type ComponentProps } from 'react';

// eslint-disable-next-line no-restricted-imports
import SUIModal from '@splunk/react-ui/Modal';

type ModalProps = ComponentProps<typeof SUIModal>;
type returnFocus = ModalProps['returnFocus'];

const stopKeyDownPropagation = (event: React.KeyboardEvent<HTMLDivElement>) => {
    // Stop propagation of most key presses. Allow escape because it closes the modal.
    if (event.key !== 'Escape') {
        event.stopPropagation();
    }
};

const FrameworkModal = ({
    children,
    onKeyDownCapture,
    ...props
}: ModalProps) => {
    const handleKeyDownCapture = useCallback<
        NonNullable<ModalProps['onKeyDownCapture']>
    >(
        (event) => {
            onKeyDownCapture?.(event);

            if (event.key === 'Escape') {
                event.preventDefault();
            }
        },
        [onKeyDownCapture]
    );

    return (
        <SUIModal
            {...props}
            onKeyDownCapture={handleKeyDownCapture}
            onKeyDown={stopKeyDownPropagation}
        >
            {children}
        </SUIModal>
    );
};

// eslint-disable-next-line no-restricted-imports
export * from '@splunk/react-ui/Modal';

Object.assign(FrameworkModal, SUIModal);
const Modal = FrameworkModal as unknown as typeof SUIModal;
export { Modal, type returnFocus };
